import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../Firebase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Card,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import imageCompression from "browser-image-compression";

function AddBlog() {
  const [blogs, setBlogs] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);

  const fetchBlogs = async () => {
    const snapshot = await getDocs(collection(db, "blogs"));
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      formattedDate: doc.data().createdAt
        ? new Date(doc.data().createdAt.seconds * 1000).toLocaleDateString()
        : "N/A",
    }));
    setBlogs(data);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const resetForm = () => {
    setTitle("");
    setContent("");
    setImage(null);
    setImagePreview(null);
    setEditingId(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setImage(null);
    const imageInput = document.getElementById("image");
    if (imageInput) {
      imageInput.value = "";
    }
  };

  const modules = {
    toolbar: [
      [
        { header: "1" },
        { header: "2" },
        { header: "3" },
        { header: "4" },
        { header: "5" },
        { header: "6" },
        { font: [] },
      ],
      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
      ["bold", "italic", "underline", "strike"],
      [{ align: [] }],
      ["link", "image", "video", "emoji"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block", "code"],
      ["clean"],
      ["direction"],
      ["show-tooltip"],
      [{ list: "checklist" }],
      [{ style: "bold" }, { style: "italic" }, { style: "underline" }, { style: "strikethrough" }],
    ],
  };

  const handleSubmit = async () => {
    if (!title || !content) return toast.error("Fill all fields");

    try {
      let imageUrl = "";

      if (image) {
        setImageUploading(true);

        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(image, options);
        const imageRef = ref(storage, `blogs/${compressedFile.name}`);
        await uploadBytes(imageRef, compressedFile);
        imageUrl = await getDownloadURL(imageRef);

        setImageUploading(false);
      }

      if (editingId) {
        await updateDoc(doc(db, "blogs", editingId), {
          title,
          content,
          imageUrl: imageUrl || blogs.find((b) => b.id === editingId)?.imageUrl || "",
        });
        toast.success("Blog updated!");
      } else {
        await addDoc(collection(db, "blogs"), {
          title,
          content,
          imageUrl,
          createdAt: serverTimestamp(),
        });
        toast.success("Blog added successfully!");
      }

      resetForm();
      setFormOpen(false);
      fetchBlogs();
    } catch (error) {
      console.error(error);
      toast.error("Error saving blog.");
      setImageUploading(false);
    }
  };

  const handleDelete = async () => {
    if (!blogToDelete) return;
    try {
      await deleteDoc(doc(db, "blogs", blogToDelete));
      toast.success("Blog deleted.");
      fetchBlogs();
    } catch (error) {
      toast.error("Error deleting blog.");
    } finally {
      setConfirmDeleteOpen(false);
      setBlogToDelete(null);
    }
  };

  const handleDeleteConfirmation = (id) => {
    setBlogToDelete(id);
    setConfirmDeleteOpen(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Blogs
                </MDTypography>
              </MDBox>
              <Grid container justifyContent="space-between" alignItems="center" p={2}>
                <Grid item>
                  <MDBox mt={2}>
                    <MDTypography variant="h6">Total Blogs : {blogs.length} </MDTypography>
                  </MDBox>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ color: "white" }}
                    startIcon={<AddIcon />}
                    onClick={() => {
                      resetForm();
                      setFormOpen(true);
                    }}
                  >
                    Add Blog
                  </Button>
                </Grid>
              </Grid>

              <TableContainer component={Paper}>
                <Table>
                  {/* <TableHead></TableHead> */}
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ color: "black", fontWeight: "bold" }}>Title</TableCell>
                      <TableCell style={{ color: "black", fontWeight: "bold" }}>Content</TableCell>
                      <TableCell style={{ color: "black", fontWeight: "bold" }}>Image</TableCell>
                      <TableCell style={{ color: "black", fontWeight: "bold" }} align="center">
                        Actions
                      </TableCell>
                    </TableRow>
                    {blogs.map((blog) => (
                      <TableRow key={blog.id}>
                        <TableCell style={{ width: "20%" }}>{blog.title}</TableCell>
                        <TableCell style={{ width: "45%" }}>
                          <div
                            dangerouslySetInnerHTML={{ __html: blog.content.slice(0, 100) + "..." }}
                          />
                        </TableCell>
                        <TableCell style={{ width: "20%" }}>
                          {blog.imageUrl && <img src={blog.imageUrl} alt="Blog" width={100} />}
                        </TableCell>
                        <TableCell align="center" style={{ width: "15%" }}>
                          <IconButton
                            onClick={() => {
                              setSelectedBlog(blog);
                              setViewOpen(true);
                            }}
                            color="success"
                          >
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setTitle(blog.title);
                              setContent(blog.content);
                              setImagePreview(blog.imageUrl);
                              setEditingId(blog.id);
                              setFormOpen(true);
                            }}
                            color="info"
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            onClick={() => handleDeleteConfirmation(blog.id)}
                            color="error"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>

        <Dialog
          open={confirmDeleteOpen}
          onClose={() => setConfirmDeleteOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this blog post?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmDeleteOpen(false)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              variant="contained"
              color="primary"
              style={{ color: "white" }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={formOpen} onClose={() => setFormOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>{editingId ? "Edit Blog" : "Add Blog"}</DialogTitle>
          <DialogContent>
            <div style={{ marginBottom: "10px" }}>
              <h5>Title</h5>
              <TextField
                label="Title"
                fullWidth
                margin="dense"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                variant="outlined"
              />
            </div>

            <div style={{ marginBottom: "10px" }}>
              <h5>Content</h5>
              {/* <ReactQuill value={content} onChange={setContent} theme="snow" /> */}
              <ReactQuill
                value={content}
                onChange={setContent}
                className="mt-1 block w-full border shadow rounded max-h-[40vh] overflow-y-auto"
                theme="snow"
                modules={modules}
              />
            </div>

            <div className="mb-4">
              <h5>Upload Image</h5>
              <input
                style={{ marginBottom: "10px" }}
                type="file"
                onChange={handleImageChange}
                id="image"
              />
            </div>

            {imagePreview && (
              <div>
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="object-cover rounded"
                  width={150}
                />
                <br />

                <IconButton onClick={handleRemoveImage} color="error">
                  <DeleteIcon />
                </IconButton>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFormOpen(false)} color="error">
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              disabled={imageUploading}
            >
              {editingId ? "Update" : "Save"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={viewOpen} onClose={() => setViewOpen(false)} maxWidth="xs">
          <DialogTitle>View Blog</DialogTitle>
          <DialogContent>
            {selectedBlog?.imageUrl && (
              <img src={selectedBlog.imageUrl} alt="Blog" className="mt-3" width="100%" />
            )}
            <div style={{ fontSize: "14px" }}>{selectedBlog?.formattedDate}</div>
            <p style={{ fontSize: "18px", color: "black", margin: "15px 0px" }}>
              {selectedBlog?.title}
            </p>
            <div dangerouslySetInnerHTML={{ __html: selectedBlog?.content }} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewOpen(false)} color="error">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default AddBlog;
